import angular from "angular";

import BicycleOwnerSettingsModuleRouting from "./bicycle-owner-settings.module.routing";

export default angular
  .module("vt-bicycle-owner-settings", [])
  .config(BicycleOwnerSettingsModuleRouting);
